/* Eleganz Bestseller: Pfeile blättern um eine Karte und springen am
   Ende an den Anfang (und umgekehrt); Fortschrittsbalken folgt dem Scrollstand;
   mit der Maus ziehbar, Pfeiltasten blättern; optional automatisches Weiterblättern.
   Karten blenden beim Scrollen ein; Neigung und Lichtreflex folgen dem Mauszeiger
   (nur feine Zeiger, nicht bei „Bewegung reduzieren“). Ohne Script wischbar. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    if (root.classList.contains('ej-best--entrance') && !reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      root.classList.add('is-in');
    }

    var list = root.querySelector('.ej-best__list');
    if (!list) return;
    var bar = root.querySelector('.ej-best__progress-bar');
    var prev = root.querySelector('.ej-best__arrow[data-dir="-1"]');
    var next = root.querySelector('.ej-best__arrow[data-dir="1"]');

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      root.classList.toggle('is-static', max <= 1);
      if (bar) {
        var w = Math.min(100, (list.clientWidth / list.scrollWidth) * 100);
        var frac = max > 0 ? list.scrollLeft / max : 0;
        root.style.setProperty('--bs-bar', w.toFixed(2) + '%');
        root.style.setProperty('--bs-bar-x', (frac * (100 - w) / w * 100).toFixed(2) + '%');
      }
    }
    // Direkt beim Scrollen: zwei Variablen und zwei Attribute, kein Layout-Schreiben
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var behavior = reduced ? 'auto' : 'smooth';
    function metrics() {
      // Erste sichtbare Karte (in Bento ist die mobile Kopie der großen Karte auf dem Desktop ausgeblendet)
      var item = Array.prototype.find.call(list.querySelectorAll('.ej-best__item'), function (i) { return i.offsetWidth > 0; });
      var cs = getComputedStyle(list);
      var gap = parseFloat(cs.columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : list.clientWidth;
      var visible = Math.max(1, Math.floor((list.clientWidth - parseFloat(cs.paddingLeft) * 2 + gap) / step));
      return { step: step, visible: visible, max: list.scrollWidth - list.clientWidth };
    }
    // Am Ende → Anfang, am Anfang → Ende
    function page(dir, cards) {
      var m = metrics();
      if (dir > 0 && list.scrollLeft >= m.max - 2) return list.scrollTo({ left: 0, behavior: behavior });
      if (dir < 0 && list.scrollLeft <= 2) return list.scrollTo({ left: m.max, behavior: behavior });
      list.scrollBy({ left: dir * m.step * (cards || m.visible), behavior: behavior });
    }
    [prev, next].forEach(function (btn) {
      // Ein Klick = eine Karte weiter (am Ende zurück zum Anfang)
      if (btn) btn.addEventListener('click', function () { page(parseInt(btn.dataset.dir, 10), 1); restart(); });
    });

    // Pfeiltasten, wenn eine Karte den Fokus hat
    list.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      page(e.key === 'ArrowRight' ? 1 : -1, 1);
    });

    // Ziehen mit der Maus; danach auf die nächste Karte einrasten, Klick unterdrücken
    if (fine) {
      var drag = null, moved = false;
      list.addEventListener('pointerdown', function (e) {
        // Nichts zu scrollen (z. B. Bento-Raster) → kein Ziehen, Klicks bleiben normal
        if (root.classList.contains('is-static')) return;
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('.ej-best__wish, .ej-best__qv, .ej-best__badges')) return;
        drag = { x: e.clientX, left: list.scrollLeft, id: e.pointerId };
        moved = false;
      });
      list.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!moved && Math.abs(dx) < 6) return;
        if (!moved) { moved = true; list.classList.add('is-dragging'); list.setPointerCapture(drag.id); }
        list.scrollLeft = drag.left - dx;
      });
      var end = function () {
        if (!drag) return;
        drag = null;
        if (!moved) return;
        list.classList.remove('is-dragging');
        var m = metrics();
        var target = Math.min(m.max, Math.round(list.scrollLeft / m.step) * m.step);
        list.scrollTo({ left: target, behavior: behavior });
        restart();
      };
      list.addEventListener('pointerup', end);
      list.addEventListener('pointercancel', end);
      list.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    // Automatisch weiterblättern (Einstellung): Pause bei Hover, Fokus,
    // außerhalb des Bildschirms und in ausgeblendeten Tabs
    var delay = parseInt(root.dataset.autoplay || '0', 10);
    var timer = 0, paused = false, visibleNow = false;
    function tick() { if (!paused && visibleNow && !document.hidden) page(1, 1); }
    function restart() {
      if (!delay || reduced) return;
      clearInterval(timer);
      timer = setInterval(tick, delay);
    }
    if (delay && !reduced) {
      root.addEventListener('pointerenter', function () { paused = true; });
      root.addEventListener('pointerleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visibleNow = entries[0].isIntersecting; }, { threshold: 0.4 }).observe(list);
      } else {
        visibleNow = true;
      }
      restart();
    }

    if (reduced || !fine || !root.classList.contains('ej-best--tilt')) return;
    root.querySelectorAll('.ej-best__card').forEach(function (card) {
      var frame = 0, px = 0.5, py = 0.5;
      function paint() {
        frame = 0;
        card.style.setProperty('--rx', ((0.5 - py) * 6).toFixed(2) + 'deg');
        card.style.setProperty('--ry', ((px - 0.5) * 8).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      }
      card.addEventListener('pointerenter', function () { card.classList.add('is-tracking'); });
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
        if (!frame) frame = requestAnimationFrame(paint);
      });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-tracking');
        if (frame) { cancelAnimationFrame(frame); frame = 0; }
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  function boot() { document.querySelectorAll('[data-ej-best]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ej-best]');
    if (el) { el.dataset.ready = ''; init(el); }
  });
})();
